import React from 'react';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import { ListItem, ListItemText, Collapse, List } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
import CollapseSubItem from './CollapseSubItem';

const CollapseItem = props => {
    const { text, subItems, classes, menuselectedsimple, submenuCollapseSelected, menuselectedcollapse, menuCollapseSelected, open, setOpen , openSub, setOpenSub, onSendData} = props
    
    const handleClick = () => {
        setOpen(!open);
        menuCollapseSelected(text)
    };
    return (
        <div>
            <ListItem onClick={handleClick} button selected = {false} className = {(text === menuselectedsimple) ? classes.menuactive : classes.menudesactive}>
            
                <ListItemText primary={<Typography
                                            component="span"
                                            variant="body2"
                                            className={classes.fontsize}
                                        >
                                            { text }
                                        </Typography>} className = { (text === menuselectedsimple) ? classes.listItemsactive : classes.listItems } />
                { (text === menuselectedsimple) ? <ExpandLess style={{ color: "rgba(255, 198, 0)" }}/> : <ExpandMore style={{ color: "rgba(255, 198, 0)" }}/> }
            </ListItem>
            <Collapse in={(text === menuselectedsimple) ? true : false} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                  {
                      subItems.map(subItem => {
                        if (subItem.type ==='collapse') {
                            const { subItems, sicon, stext, state } = subItem

                            if (subItem.svg) {
                                return <CollapseSubItem
                                    svg={subItem.svg}
                                    svgRoute={subItem.svgRoute}
                                    key={stext}
                                    icon={sicon}
                                    text={stext}
                                    state={state}
                                    subItems={subItems}
                                    onSendData={(r, t) => onSendData(r, t)}
                                    classes={classes}
                                    menuselectedsimple={menuselectedsimple}
                                    menuCollapseSelected={menuCollapseSelected}
                                    menuselectedcollapse={menuselectedcollapse}
                                    submenuCollapseSelected={(r, t, tf) => submenuCollapseSelected(r, t, tf)}
                                    open={openSub} setOpen={(s) => setOpenSub(s)

                                    } />
                            }
                            
                        }else{
                            const { stext, sroute, state } = subItem
                            if(state){
                                return  <ListItem key={stext} button = { (isMobile) ? false : true } onClick = {() => submenuCollapseSelected(sroute, stext, text)} className = {(stext === menuselectedcollapse) ? classes.listSubItemsactivebackground : classes.listSubItemsdesactivebackground} >
                                            
                                            <ListItemText primary={<Typography
                                                                        component="span"
                                                                        variant="body2"
                                                                        className={classes.fontsize}
                                                                    >
                                                                        { stext }
                                                                    </Typography>} className = { (stext === menuselectedcollapse) ? classes.listSubItemsactive : classes.listItemsdesactive }/>
                                        </ListItem>
                            }else { return null }     
                        }  
                        return null                      
                      })
                  }
              </List>
            </Collapse>
        </div>
    );
};

CollapseItem.propTypes = {
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    subItems: PropTypes.array.isRequired,
    onSendData: PropTypes.func.isRequired,
};

export default CollapseItem;